<aside
  *ngIf="isEnabled"
  class="notice-banner"
  [attr.aria-label]="'wl.star.notice_banner.aria_label' | translate">
  <div class="notice-banner-container flex items-start justify-center py-2">
    <rd-shared-icon
      class="notice-banner-icon mr-1.5 shrink-0"
      [iconSymbol]="'icon-info'"
      [iconTheme]="'warn'"></rd-shared-icon>
    <p
      class="notice-banner-message m-0"
      [innerHTML]="'wl.star.notice_banner.message' | translate"></p>
  </div>
</aside>
